import React from 'react';
import { setBackgroundColor } from '../../../utility';

const EmptySpace = ({ section }) => (
  <section className='empty-space' style={setBackgroundColor(section?.background_color), { height: `${section?.height}px` }} />
);

export default EmptySpace;